var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 25,
    viewBox: "0 0 33 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_394_5432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.996094 0.601234H32.9961V8.6333H0.996094V0.601234Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.996094 8.6333H32.9961V16.6654H0.996094V8.6333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.996094 16.6654H32.9961V24.6974H0.996094V16.6654Z",
    fill: "#128807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9969 15.8622C18.7642 15.8622 20.1969 14.4238 20.1969 12.6494C20.1969 10.875 18.7642 9.43657 16.9969 9.43657C15.2296 9.43657 13.7969 10.875 13.7969 12.6494C13.7969 14.4238 15.2296 15.8622 16.9969 15.8622Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9953 15.4605C18.5417 15.4605 19.7953 14.2019 19.7953 12.6493C19.7953 11.0967 18.5417 9.83806 16.9953 9.83806C15.4489 9.83806 14.1953 11.0967 14.1953 12.6493C14.1953 14.2019 15.4489 15.4605 16.9953 15.4605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9955 13.2118C17.3048 13.2118 17.5555 12.96 17.5555 12.6495C17.5555 12.339 17.3048 12.0873 16.9955 12.0873C16.6863 12.0873 16.4355 12.339 16.4355 12.6495C16.4355 12.96 16.6863 13.2118 16.9955 13.2118Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7555 13.1614C19.8343 13.1718 19.9067 13.1159 19.9171 13.0366C19.9275 12.9573 19.872 12.8845 19.7932 12.8741C19.7143 12.8637 19.642 12.9195 19.6316 12.9989C19.6212 13.0782 19.6766 13.1509 19.7555 13.1614Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9983 15.4609L17.0943 13.7742L16.9983 12.971L16.9023 13.7742L16.9983 15.4609Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5328 13.8602C19.6064 13.8908 19.6907 13.8558 19.7211 13.7819C19.7515 13.7081 19.7166 13.6235 19.643 13.5928C19.5694 13.5622 19.4851 13.5972 19.4547 13.671C19.4243 13.7449 19.4592 13.8295 19.5328 13.8602Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2778 15.3648L16.8052 13.7607L16.9192 12.9599L16.6193 13.7107L16.2778 15.3648Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1345 14.4766C19.1977 14.5254 19.2882 14.5135 19.3366 14.4501C19.385 14.3868 19.373 14.2959 19.3098 14.2472C19.2466 14.1985 19.1561 14.2104 19.1077 14.2737C19.0593 14.3371 19.0713 14.4279 19.1345 14.4766Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6034 15.0839L16.5265 13.6716L16.8431 12.9278L16.3599 13.575L15.6034 15.0839Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5917 14.9688C18.6402 15.0323 18.7307 15.0443 18.7938 14.9957C18.8569 14.9471 18.8688 14.8563 18.8203 14.7928C18.7717 14.7293 18.6813 14.7173 18.6182 14.7659C18.555 14.8145 18.5432 14.9054 18.5917 14.9688Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0216 14.6373L16.2774 13.513L16.775 12.8769L16.1414 13.3765L15.0216 14.6373Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9311 15.3027C17.9615 15.3765 18.0458 15.4115 18.1194 15.3808C18.193 15.3502 18.228 15.2655 18.1976 15.1917C18.1672 15.1179 18.0829 15.083 18.0093 15.1136C17.9357 15.1443 17.9006 15.2289 17.9311 15.3027Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5699 14.0551L16.0728 13.2948L16.7178 12.8098L15.977 13.1282L14.5699 14.0551Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2248 15.4557C17.2351 15.5349 17.3075 15.5906 17.3865 15.5801C17.4655 15.5696 17.5212 15.4969 17.5109 15.4177C17.5006 15.3386 17.4281 15.2829 17.3491 15.2934C17.2701 15.3039 17.2145 15.3766 17.2248 15.4557Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2971 13.3771L15.9447 13.0331L16.6927 12.7322L15.8952 12.8474L14.2971 13.3771Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4945 15.4179C16.484 15.4973 16.5394 15.57 16.6182 15.5804C16.6971 15.5908 16.7694 15.5348 16.7799 15.4555C16.7904 15.3761 16.7349 15.3034 16.6561 15.293C16.5773 15.2827 16.5049 15.3386 16.4945 15.4179Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2037 12.6504L15.8835 12.7443L16.6835 12.6483L15.8836 12.5536L14.2037 12.6504Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7958 15.1911C15.7653 15.2649 15.8001 15.3496 15.8736 15.3802C15.9472 15.4107 16.0315 15.3756 16.062 15.3017C16.0925 15.2278 16.0576 15.1432 15.9841 15.1126C15.9106 15.0821 15.8263 15.1172 15.7958 15.1911Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2965 11.9217L15.8943 12.4514L16.6919 12.5659L15.9441 12.2649L14.2965 11.9217Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1834 14.7909C15.135 14.8542 15.147 14.9451 15.2102 14.9938C15.2735 15.0425 15.3639 15.0306 15.4124 14.9673C15.4608 14.9039 15.4488 14.8131 15.3855 14.7644C15.3223 14.7156 15.2318 14.7275 15.1834 14.7909Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5776 11.2434L15.9848 12.1703L16.7255 12.4887L16.0805 12.0037L14.5776 11.2434Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6846 14.2447C14.6215 14.2933 14.6097 14.3841 14.6583 14.4476C14.7068 14.5111 14.7973 14.5231 14.8604 14.4745C14.9235 14.4259 14.9353 14.3351 14.8868 14.2716C14.8382 14.2081 14.7478 14.1961 14.6846 14.2447Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0143 10.6612L16.1347 11.9221L16.7682 12.4221L16.2702 11.786L15.0143 10.6612Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3521 13.5905C14.2786 13.621 14.2438 13.7057 14.2743 13.7796C14.3048 13.8535 14.3891 13.8886 14.4626 13.8581C14.5361 13.8275 14.571 13.7429 14.5405 13.669C14.51 13.5951 14.4256 13.5599 14.3521 13.5905Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5947 10.2148L16.3519 11.7238L16.8349 12.3713L16.5179 11.6276L15.5947 10.2148Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1983 12.8716C14.1194 12.882 14.0639 12.9547 14.0744 13.034C14.0848 13.1133 14.1572 13.1691 14.2361 13.1587C14.315 13.1483 14.3704 13.0756 14.36 12.9963C14.3496 12.917 14.2772 12.8612 14.1983 12.8716Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2691 9.93396L16.6116 11.5882L16.9114 12.3392L16.7967 11.5384L16.2691 9.93396Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2459 12.1378C14.1669 12.1273 14.0945 12.183 14.0842 12.2622C14.0739 12.3413 14.1295 12.414 14.2085 12.4245C14.2875 12.435 14.3599 12.3793 14.3703 12.3002C14.3806 12.221 14.3249 12.1483 14.2459 12.1378Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0026 9.83816L16.909 11.5247L17.0047 12.3279L17.0989 11.5249L17.0026 9.83816Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.471 11.4387C14.3974 11.408 14.3131 11.443 14.2827 11.5168C14.2523 11.5906 14.2873 11.6753 14.3609 11.7059C14.4345 11.7365 14.5188 11.7016 14.5492 11.6278C14.5796 11.554 14.5446 11.4693 14.471 11.4387Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7261 9.93392L17.1987 11.538L17.0848 12.3388L17.3846 11.5881L17.7261 9.93392Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8597 10.8221C14.7965 10.7734 14.706 10.7853 14.6576 10.8486C14.6092 10.912 14.6212 11.0028 14.6844 11.0516C14.7476 11.1003 14.8381 11.0884 14.8865 11.025C14.9349 10.9617 14.9229 10.8708 14.8597 10.8221Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3907 10.2149L17.4677 11.6272L17.1511 12.371L17.6343 11.7238L18.3907 10.2149Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4043 10.3299C15.3558 10.2665 15.2653 10.2544 15.2022 10.303C15.1391 10.3516 15.1273 10.4425 15.1758 10.5059C15.2243 10.5694 15.3148 10.5815 15.3779 10.5329C15.441 10.4843 15.4528 10.3934 15.4043 10.3299Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9744 10.6614L17.7187 11.7857L17.2211 12.4218L17.8547 11.9223L18.9744 10.6614Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.069 9.99635C16.0385 9.92257 15.9542 9.88761 15.8806 9.91826C15.807 9.94891 15.772 10.0336 15.8024 10.1073C15.8328 10.1811 15.9171 10.2161 15.9907 10.1854C16.0643 10.1548 16.0994 10.0701 16.069 9.99635Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4301 11.2439L17.9272 12.0042L17.2822 12.4892L18.023 12.1708L19.4301 11.2439Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7752 9.84331C16.7649 9.76414 16.6925 9.70847 16.6135 9.71897C16.5345 9.72946 16.4788 9.80215 16.4891 9.88132C16.4994 9.96049 16.5719 10.0162 16.6509 10.0057C16.7299 9.99517 16.7855 9.92248 16.7752 9.84331Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7029 11.9219L18.0553 12.266L17.3073 12.5669L18.1048 12.4517L19.7029 11.9219Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5075 9.88101C17.518 9.80166 17.4626 9.72893 17.3837 9.71858C17.3049 9.70822 17.2325 9.76415 17.2221 9.84351C17.2116 9.92286 17.267 9.99559 17.3458 10.0059C17.4247 10.0163 17.497 9.96037 17.5075 9.88101Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8002 12.6484L18.1204 12.5548L17.3204 12.6508L18.1203 12.7452L19.8002 12.6484Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2042 10.1079C18.2347 10.0341 18.1999 9.94939 18.1264 9.91884C18.0529 9.8883 17.9686 9.92343 17.938 9.99732C17.9075 10.0712 17.9424 10.1559 18.0159 10.1864C18.0894 10.217 18.1737 10.1818 18.2042 10.1079Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7035 13.3772L18.1057 12.8476L17.3081 12.7331L18.0559 13.0342L19.7035 13.3772Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8242 10.508C18.8727 10.4445 18.8608 10.3537 18.7977 10.305C18.7346 10.2564 18.6441 10.2684 18.5956 10.3319C18.5471 10.3953 18.559 10.4862 18.6221 10.5348C18.6852 10.5834 18.7757 10.5714 18.8242 10.508Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4301 14.0553L18.0233 13.1285L17.2824 12.8105L17.9272 13.2956L19.4301 14.0553Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3171 11.0541C19.3803 11.0054 19.3923 10.9145 19.3439 10.8512C19.2954 10.7878 19.2049 10.7759 19.1418 10.8246C19.0786 10.8732 19.0666 10.9641 19.115 11.0275C19.1635 11.0908 19.254 11.1028 19.3171 11.0541Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9875 14.6376L17.8676 13.3768L17.234 12.8771L17.7317 13.5132L18.9875 14.6376Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.638 11.7083C19.7116 11.6777 19.7465 11.593 19.7161 11.5192C19.6857 11.4454 19.6013 11.4104 19.5278 11.441C19.4542 11.4716 19.4192 11.5563 19.4496 11.6301C19.4801 11.7039 19.5644 11.7389 19.638 11.7083Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3953 15.084L17.6386 13.5751L17.1555 12.9278L17.4722 13.6716L18.3953 15.084Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7996 12.4271C19.8786 12.4167 19.9342 12.344 19.9238 12.2648C19.9135 12.1856 19.8411 12.1298 19.7621 12.1403C19.6832 12.1508 19.6275 12.2235 19.6379 12.3027C19.6483 12.3819 19.7207 12.4376 19.7996 12.4271Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7286 15.3648L17.3868 13.7106L17.087 12.9598L17.2011 13.7606L17.7286 15.3648Z",
    fill: "#000088"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_394_5432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24.0962,
    fill: "white",
    transform: "translate(0.996094 0.601234)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/India.d89fd164c5c01668b0360cac04d2f368.svg";
export { ForwardRef as ReactComponent };